import { Bank } from '@ap/interface-bspc-core';

export interface LijstVanActieveConfiguraties {
    configuraties?: ActieveConfiguratie[];
}

export interface ActieveConfiguratie {
    naam: string;
    waarde: string;
}

export interface LijstVanConfiguraties {
    heeft_mutatierecht: boolean;
    configuraties?: Configuratie[];
}

export interface Configuratie {
    kanaal: string;
    configuratie_type: string;
    naam: string;
    waardes: ConfiguratieWaarde[];
    id?: string;
    is_waarde_per_bank_actief?: boolean;
    omschrijving?: string;
    gewijzigd_op?: string;
    gewijzigd_door?: string;
}

export interface ConfiguratieWaarde {
    waarde: string;
    bank?: Bank;
    actief_vanaf?: string;
    actief_tot?: string;
}

export interface LijstVanConfiguratieLogs {
    configuratie_logs: ConfiguratieLog[];
}

export interface ConfiguratieLog {
    configuratie_id: string;
    rfc: string;
    mutatie_type: MutatieType;
    kanaal: string;
    configuratie_type: string;
    naam: string;
    id?: string;
    omschrijving?: string;
    is_waarde_per_bank_actief?: boolean;
    waardes?: string;
    gewijzigd_op?: string;
    gewijzigd_door?: string;
}

export enum MutatieType {
    GEWIJZIGD = 'gewijzigd',
    TOEGEVOEGD = 'toegevoegd',
    VERWIJDERD = 'verwijderd'
}

export interface LijstVanConfiguratieTypes {
    configuratie_types?: ConfiguratieType[];
}

export interface ConfiguratieType {
    naam: string;
    id?: string;
    patroon?: string;
    is_json?: boolean;
    gewijzigd_op?: string;
    gewijzigd_door?: string;
}

export interface LijstVanKanalen {
    kanalen?: Kanaal[];
}

export interface Kanaal {
    naam: string;
    id?: string;
    gewijzigd_op?: string;
    gewijzigd_door?: string;
}

export interface RfcInformatie {
    korte_omschrijving: string;
    rfc_nummer: string;
    status: string;
}
